import React from "react";

export default class VacancesOFPPT2026 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedLang: "fr",
      now: new Date(),
      vacances: [
        // ✅ هادو الثلاثة اللي دازو
        {
          id: 1,
          event: { fr: "Mawlid Nabawi", ar: "المولد النبوي", en: "Prophet’s Birthday" },
          dates: "12 et 13 Rabii I 1447 ",
          mois: "Octobre",
          jours: 1,
          eventDate: new Date("2025-10-16T00:00:00"),
        },
        {
          id: 2,
          event: { fr: "Anniversaire de la Marche Verte", ar: "ذكرى المسيرة الخضراء", en: "Green March Anniversary" },
          dates: "Jeudi 6 Novembre 2025",
          mois: "Novembre",
          jours: 1,
          eventDate: new Date("2025-11-06T00:00:00"),
        },
        {
          id: 3,
          event: { fr: "Fête de l'Indépendance", ar: "عيد الاستقلال", en: "Independence Day" },
          dates: "Mardi 18 Novembre 2025",
          mois: "Novembre",
          jours: 1,
          eventDate: new Date("2025-11-18T00:00:00"),
        },

        // ✅ باقي العطل
        {
          id: 4,
          event: { fr: "Vacances du 1er trimestre", ar: "عطلة الدورة الأولى", en: "1st Term Vacation" },
          dates: "Du Dimanche 7 Décembre 2025 au Dimanche 14 Décembre 2025",
          mois: "Décembre",
          jours: 8,
          eventDate: new Date("2025-12-07T00:00:00"),
        },
        {
          id: 5,
          event: { fr: "Nouvel an", ar: "رأس السنة الميلادية", en: "New Year" },
          dates: "Jeudi 1 Janvier 2026",
          mois: "Janvier",
          jours: 1,
          eventDate: new Date("2026-01-01T00:00:00"),
        },
        {
          id: 6,
          event: { fr: "Manifeste de l'Indépendance", ar: "تقديم وثيقة الاستقلال", en: "Proclamation of Independence" },
          dates: "Dimanche 11 Janvier 2026",
          mois: "Janvier",
          jours: 1,
          eventDate: new Date("2026-01-11T00:00:00"),
        },
        {
          id: 7,
          event: { fr: "Nouvel An Amazigh", ar: "رأس السنة الأمازيغية", en: "Amazigh New Year" },
          dates: "Mercredi 14 Janvier 2026",
          mois: "Janvier",
          jours: 1,
          eventDate: new Date("2026-01-14T00:00:00"),
        },
        {
          id: 8,
          event: { fr: "Vacances de la mi-année", ar: "عطلة منتصف السنة", en: "Mid-Year Vacation" },
          dates: "Du Dimanche 25 Janvier 2026 au Dimanche 1 Février 2026",
          mois: "Janvier/Février",
          jours: 8,
          eventDate: new Date("2026-01-25T00:00:00"),
        },
        {
          id: 9,
          event: { fr: "Vacances du 2ème trimestre", ar: "عطلة الدورة الثانية", en: "2nd Term Vacation" },
          dates: "Du Dimanche 15 Mars 2026 au Dimanche 22 Mars 2026",
          mois: "Mars",
          jours: 8,
          eventDate: new Date("2026-03-15T00:00:00"),
        },
        {
          id: 10,
          event: { fr: "Aid Al Fitr", ar: "عيد الفطر", en: "Eid Al-Fitr" },
          dates: "Du 29 Ramadan au 2 Chaoual (à confirmer)",
          mois: "Mars/Avril",
          jours: "3 ou 4",
          eventDate: new Date("2026-03-29T00:00:00"),
        },
        {
          id: 11,
          event: { fr: "Fête du travail", ar: "عيد الشغل", en: "Labour Day" },
          dates: "Vendredi 1 Mai 2026",
          mois: "Mai",
          jours: 1,
          eventDate: new Date("2026-05-01T00:00:00"),
        },
        {
          id: 12,
          event: { fr: "Vacances du 3ème trimestre", ar: "عطلة الدورة الثالثة", en: "3rd Term Vacation" },
          dates: "Du Dimanche 3 Mai 2026 au Dimanche 10 Mai 2026",
          mois: "Mai",
          jours: 8,
          eventDate: new Date("2026-05-03T00:00:00"),
        },
        {
          id: 13,
          event: { fr: "Aid Al Adha", ar: "عيد الأضحى", en: "Eid Al-Adha" },
          dates: "Du 9 au 11 Dhou al-Hijja (à confirmer)",
          mois: "Juin",
          jours: 4,
          eventDate: new Date("2026-06-09T00:00:00"),
        },
        {
          id: 14,
          event: { fr: "1er Muharram", ar: "رأس السنة الهجرية", en: "Islamic New Year" },
          dates: "1er Muharram 1448 (à confirmer)",
          mois: "Juillet",
          jours: 1,
          eventDate: new Date("2026-07-17T00:00:00"),
        },
      ],
    };
  }

  componentDidMount() {
    this.timer = setInterval(() => {
      this.setState({ now: new Date() });
    }, 1000);
  }

  componentWillUnmount() {
    clearInterval(this.timer);
  }

  handleLangChange = (event) => {
    this.setState({ selectedLang: event.target.value });
  };

  calculateTimeLeft(eventDate) {
    const diff = eventDate - this.state.now;
    if (diff <= 0) return "Événement passé";
    const days = Math.floor(diff / (1000 * 60 * 60 * 24));
    const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
    const minutes = Math.floor((diff / (1000 * 60)) % 60);
    const seconds = Math.floor((diff / 1000) % 60);
    return `${days}j ${hours}h ${minutes}min ${seconds}s`;
  }

  render() {
    const { selectedLang, vacances, now } = this.state;

    // ترتيب: اللي دازو فالأول
    const sortedVacances = [...vacances].sort((a, b) => a.eventDate - b.eventDate);

    return (
      <div style={styles.container}>
        <h1 style={styles.title}>📅 Calendrier des Vacances OFPPT 2025-2026</h1>

        <div style={styles.langSelector}>
          <label htmlFor="lang-select" style={styles.label}>Langue :</label>
          <select id="lang-select" value={selectedLang} onChange={this.handleLangChange} style={styles.select}>
            <option value="fr">Français</option>
            <option value="ar">العربية</option>
            <option value="en">English</option>
          </select>
        </div>

        <table style={styles.table}>
          <thead>
            <tr>
              <th style={styles.th}>Événement</th>
              <th style={styles.th}>Mois</th>
              <th style={styles.th}>Dates</th>
              <th style={styles.th}>Durée</th>
              <th style={styles.th}>Temps restant</th>
            </tr>
          </thead>
          <tbody>
            {sortedVacances.map((vac) => {
              const timeLeft = this.calculateTimeLeft(vac.eventDate);
              const isPast = timeLeft === "Événement passé";

              return (
                <tr key={vac.id} style={isPast ? styles.pastRow : {}}>
                  <td style={styles.td}>{vac.event[selectedLang]}</td>
                  <td style={styles.td}>{vac.mois}</td>
                  <td style={styles.td}>{vac.dates}</td>
                  <td style={styles.td}>{vac.jours}</td>
                  <td
                    style={{
                      ...styles.td,
                      color: isPast ? "red" : "green",
                      fontWeight: "bold",
                    }}
                  >
                    {isPast ? "Événement passé" : timeLeft}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    );
  }
}

const styles = {
  container: {
    padding: "20px",
    fontFamily: "Arial, sans-serif",
    backgroundColor: "#f9f9f9",
    textAlign: "center",
    borderRadius: "10px",
  },
  title: {
    fontSize: "28px",
    color: "#007bff",
    marginBottom: "20px",
  },
  table: {
    width: "100%",
    borderCollapse: "collapse",
  },
  th: {
    backgroundColor: "#0056b3",
    color: "white",
    padding: "10px",
  },
  td: {
    padding: "10px",
    borderBottom: "1px solid #ccc",
  },
  pastRow: {
    backgroundColor: "#ffe6e6",
  },
  langSelector: {
    marginBottom: "20px",
  },
  select: {
    padding: "8px",
    borderRadius: "5px",
  },
  label: {
    fontWeight: "bold",
    marginRight: "10px",
  },
};
